import { UserCircle2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const STAFF = ["admin", "super_admin", "operations", "support", "finance", "warehouse_manager"];

export default function SessionBanner() {
  const { user } = useAuth();
  if (!user) return null;
  const role = (user.role || "customer").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  const pill = user.role === "franchise"
    ? "border-[#FF9933]/40 bg-[#FF9933]/15 text-[#FF9933]"
    : STAFF.includes(user.role)
      ? "border-shipany-cyan/40 bg-shipany-cyan/15 text-shipany-cyan"
      : "border-shipany-blue/40 bg-shipany-blue/15 text-sky-400";

  return (
    <div className="flex items-center justify-center gap-2 bg-shipany-navy px-4 py-1.5 text-[11px] font-medium text-slate-400" data-testid="session-banner">
      <UserCircle2 className="h-3.5 w-3.5 text-slate-500" />
      <span className="truncate">
        Signed in as <span className="font-bold text-white" data-testid="session-banner-email">{user.email}</span>
      </span>
      <span className={`rounded-full border px-2 py-px text-[10px] font-bold uppercase tracking-wider ${pill}`} data-testid="session-banner-role">{role}</span>
    </div>
  );
}
